<template>
<drawer :opened.sync="opened" @close="onCloseBtnClick">
  <template #header>配置<span style="color:#409EFF;">{{currentFactor.displayName}}</span>比值因子</template>

  <template #body>
    <el-form ref="form" :model="model">
      <el-row
        v-for="(specificValueFactor, index) in model.specificValueFactors"
        :key="index"
        :gutter="gutter"
      >
        <el-col :span="8">
          <el-form-item
            label="比值因子"
            :prop="`specificValueFactors[${index}].specificValueFactorId`"
            :rules="[{
              required: true,
              message: '请选择比值因子'
            }]"
          >
            <el-cascader
              v-model="specificValueFactor.specificValueFactorId"
              :options="factorTrees[index]"
              :show-all-levels="false"
              :props="{
                expandTrigger: 'click',
                value: 'id',
                label: 'name',
                emitPath: false
              }"
              style="width:100%;"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            label="比值系数下限"
            :prop="`specificValueFactors[${index}].specificValueLow`"
            :rules="[{
              required: true,
              message: '请输入相关系数下限'
            }]"
          >
            <el-input v-model="specificValueFactor.specificValueLow" type="number" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </template>

  <template #footer>
    <el-button type="orange" plain class="btn save-continue-btn" @click="onCreateRelatedFactorBtnClick">新增比值因子</el-button>
    <el-button type="orange" class="btn save-btn" @click="onSaveBtnClick">保存</el-button>
    <a class="cancel-btn btn" @click="onCloseBtnClick">关闭</a>
  </template>
</drawer>
</template>

<script>
import BaseEditor from '../../../BaseEditor'

export default {
  name: 'SpecificFactorEditor',
  extends: BaseEditor,
  props: {
    currentFactor: {
      required: true,
      type: Object
    }
  },
  computed: {
    apiKey () {
      return 'SpecificFactor'
    },
    idKey () {
      return 'id'
    },
    nameKey () {
      return ''
    },
    editName () {
      return '相关因子'
    },
    filterFactors () {
      let {id} = this.currentFactor
      return this.factors.filter(factor => factor.id !== id)
    },
    factorTrees () {
      let specificFactorIds = this.model.specificValueFactors.map(specificFactorData => specificFactorData.specificFactorId)

      return specificFactorIds.map((specificFactorId, index) => {
        let filterSpecificFactorIds = [...specificFactorIds]
        filterSpecificFactorIds.splice(index, 1)

        let specificFactorIdMap = specificFactorIds.reduce((map, specificFactorId) => {
          map[specificFactorId] = true
          return map
        }, {})

        let factors = JSON.parse(JSON.stringify(this.filterFactors))
        let factorGroupMap = JSON.parse(JSON.stringify(this.factorGroupMap))
        let filterFactors = factors.filter(factor => !specificFactorIdMap[factor.id])
        let roots = []

        for (let i = 0; i < filterFactors.length; i++) {
          let item = filterFactors[i]
          let {parentId} = item

          if (parentId) {
            let parent = factorGroupMap[parentId]

            if (!parent) {
              continue
            }

            let {children} = parent

            if (!Array.isArray(children)) {
              children = parent.children = []
              filterFactors.push(parent)
            }

            children.push(item)
          } else {
            roots.push(item)
          }
        }

        return roots
      })
    }
  },
  methods: {
    initModel () {
      return {
        factorId: this.currentFactor.id,
        specificValueFactors: [this.getSpecificFactorModel()]
      }
    },
    getSpecificFactorModel () {
      return {
        factorId: this.currentFactor.id,
        specificValueFactorId: null,
        specificValueLow: null
      }
    },
    afterGetDetail (model) {
      let {specificValueFactors} = model

      if (specificValueFactors.length === 0) {
        specificValueFactors.push(this.getSpecificFactorModel())
      }
    },
    onCreateRelatedFactorBtnClick () {
      this.model.specificValueFactors.push(this.getSpecificFactorModel())
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/09System-Settings/04Config/04Factor/RatioFactorEditor.vue